export default __webpack_public_path__ + "static/fire_extinguisher_b.df2621edd5e1f3f216636d251f3b3b0d.svg";